import React from 'react';
import { observer } from 'mobx-react-lite';
import '../smart-policy-modal/smart-policy-modal.scss';
import CustomButton from '../../../shared/custom-button/custom-button';
import PolicyNotesPopover from '../../../shared/policy-notes-popover/policy-notes-popover';

interface SmartReadyModalContentProps {
    setDisplayPolicySummary: (visible: boolean) => void;
}

export const SmartReadyModalContent: React.FC<SmartReadyModalContentProps> = observer(({ setDisplayPolicySummary }) => {

    return <div className="policy-content">
        <div
            className="policy-title">Your Smart Protection policy draft is ready
        </div>
        <div className="policy-subtitle">
            {`After analyzing your network traffic, we've collected the necessary data to ` +
                `tailor a security policy that aligns with your business' protection needs.\n` +
                `To get your policy up and running, you need to Apply Policy. ` +
                `You can review the policy first and make any adjustments if needed.`}
        </div>
        <PolicyNotesPopover />
        <div className="policy-footer">
            <div className="policy-action-btn-wrapper">
                <CustomButton
                    className="primary-btn btn-edit"
                    label="Policy Summary"
                    onClick={() => setDisplayPolicySummary(true)}
                />
            </div>
        </div>
    </div>;
});
